import { HostListener, Inject, Injectable } from '@angular/core';
import { GStatic } from '../../services/GStatic';
import { TranslocoService } from '@ngneat/transloco';
import { FuseMediaWatcherService } from '../../../@fuse/services/media-watcher';
import { DebugViewService } from '../../services/debug-view.service';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

export interface HeaderController {
  title?: string;
  loading?: number;
  navbar?: boolean;
  floatingButton?: boolean;
  actionLinks?: any[];
}

export interface ScreenSize {
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | string;
  sizePx: number;
  sizeIndex: number;
  isDevice: boolean;
  matchingAliases: string[];
  gtXs: boolean;
  gtSm: boolean;
  gtMd: boolean;
  gtLg: boolean;
  gtXl: boolean;
  ltXs: boolean;
  ltSm: boolean;
  ltMd: boolean;
  ltLg: boolean;
  ltXl: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ProjectLayoutService {
  public dashboardMenuIsOpen: boolean = true;
  public dashboardMenuIsDense: boolean = !GStatic.isMobile();

  public screenSize: ScreenSize = {} as ScreenSize;
  private screenSizeSubject = new BehaviorSubject<ScreenSize>(this.screenSize);
  readonly screenSize$ = this.screenSizeSubject.asObservable();

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private translocoService: TranslocoService,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private _debug: DebugViewService,
  ) {
    this._fuseMediaWatcherService.onMediaChange$.subscribe((matchingAliases) => {
      this.screenSize = {
        size: matchingAliases.matchingAliases.length
          ? matchingAliases.matchingAliases[matchingAliases.matchingAliases.length - 1]
          : 'xs',
        sizePx: window.innerWidth,
        sizeIndex: matchingAliases.matchingAliases.length,
        isDevice: GStatic.isMobile(),
        matchingAliases: matchingAliases.matchingAliases,
        gtXs: true,
        gtSm: matchingAliases.matchingAliases.includes('sm'),
        gtMd: matchingAliases.matchingAliases.includes('md'),
        gtLg: matchingAliases.matchingAliases.includes('lg'),
        gtXl: matchingAliases.matchingAliases.includes('xl'),

        ltXs: matchingAliases.matchingAliases.length === 0,
        ltSm: matchingAliases.matchingAliases.length === 1,
        ltMd: matchingAliases.matchingAliases.length === 2,
        ltLg: matchingAliases.matchingAliases.length === 3,
        ltXl: matchingAliases.matchingAliases.length === 4,
      };

      this.dashboardMenuIsDense = this.screenSize.gtLg;
      this.screenSizeSubject.next(this.screenSize);
      _debug.addDebug('screenSize----', this.screenSize);
    });
  }

  pageTitle: string = '';

  loading: 0;
  headerController: HeaderController = {
    navbar: false,
    floatingButton: false,
    actionLinks: [],
  };

  toggleDashboardMenu(val?: boolean): boolean {
    this.dashboardMenuIsDense = true;
    if (val !== undefined) {
      this.dashboardMenuIsOpen = val;
    } else {
      this.dashboardMenuIsOpen = !this.dashboardMenuIsOpen;
    }
    return this.dashboardMenuIsOpen;
  }
}
